import React from 'react';
import BookingForm from '../../Components/Booking/BookingForm'; // Change back from test folder
import { Clock, Calendar, CreditCard, PhoneCall } from 'lucide-react';

const BookingPage = () => {
  return (
    <div className="min-h-screen bg-accent-lighter py-12 pt-24 px-2">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header Section */}
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Book a Service</h1>
          <p className="text-md md:text-lg text-gray-600 max-w-2xl mx-auto">
            Schedule your appointment with our experienced professionals. Choose from our wide range of services and find a time that works best for you.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-12">
          {[
            {
              icon: <Clock className="w-6 h-6 text-primary" />,
              title: "Flexible Timing",
              description: "Choose from various time slots that fit your schedule"
            },
            {
              icon: <Calendar className="w-6 h-6 text-primary" />,
              title: "Easy Scheduling",
              description: "Simple and quick booking process"
            },
            {
              icon: <CreditCard className="w-6 h-6 text-primary" />,
              title: "Secure Payment",
              description: "Safe and protected payment processing"
            },
            {
              icon: <PhoneCall className="w-6 h-6 text-primary" />,
              title: "24/7 Support",
              description: "Always here to help with your bookings"
            }
          ].map((feature, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-sm text-center">
              <div className="flex justify-center mb-4">{feature.icon}</div>
              <h3 className="text-lg font-semibold mb-2">{feature.title}</h3>
              <p className="text-gray-600 text-sm">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* Important Notes */}
        <div className="bg-secondary border border-pink-100 rounded-lg p-6 mb-12">
          <h3 className="text-lg font-semibold mb-4 text-pink-800">
           Important Information
          </h3>
          <ul className="space-y-2 text-pink-700">
            <li>• Please arrive 10 minutes before your scheduled appointment</li>
            <li>• 24-hour cancellation notice required</li>
            <li>• A valid phone number is required for booking confirmation</li>
            <li>• Payment is required to secure your booking</li>
          </ul>
        </div>

        {/* Booking Form */}
        <BookingForm />

        {/* Footer Note */}
        {/* <div className="mt-12 text-center text-gray-600 text-sm">
          <p>Need help with your booking? Contact our support team at support@example.com</p>
        </div> */}
      </div>
    </div>
  );
};

export default BookingPage;